(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('CommunicationAutomationConfDeleteController',CommunicationAutomationConfDeleteController);

    CommunicationAutomationConfDeleteController.$inject = ['$uibModalInstance', 'entity', 'CommunicationAutomationConf'];

    function CommunicationAutomationConfDeleteController($uibModalInstance, entity, CommunicationAutomationConf) {
        var vm = this;
        vm.communicationAutomationConf = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            CommunicationAutomationConf.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
